import type {
  AdminTenantDetail,
  ComponentUsageResponse,
  DeleteCheckResponse,
  TenantApiRateLimit,
  TenantOverviewRow,
  UpdateTenantApiRateLimitRequest,
} from "@repo/shared/types";
import { get, put } from "./_client";

export function checkFeatureFlag(flagKey: string) {
  return get<{ enabled: boolean }>(`/internal/admin/feature-flags/check/${flagKey}`);
}

export function getTenantDetail(id: string) {
  return get<AdminTenantDetail>(`/internal/admin/tenants/${id}`);
}

/** QL-168 — asked when Delete is clicked, before the confirmation (Quantfolio only). */
export function checkTenantDelete(id: string) {
  return get<DeleteCheckResponse>(`/internal/admin/tenants/${id}/delete-check`);
}

/** QL-359 — Quantfolio only; `limit: null` restores the default allowance. */
export function updateTenantApiRateLimit(id: string, payload: UpdateTenantApiRateLimitRequest) {
  return put<TenantApiRateLimit>(
    `/internal/admin/tenants/${id}/api-rate-limit`,
    payload satisfies UpdateTenantApiRateLimitRequest,
  );
}

export function getTenantsOverview() {
  return get<TenantOverviewRow[]>("/internal/admin/tenants/overview");
}

export function getComponentUsage() {
  return get<ComponentUsageResponse>("/internal/admin/component-usage");
}
